/* eslint-disable react-hooks/exhaustive-deps */
/* eslint-disable import/extensions */
/* eslint-disable import/no-unresolved */
/* eslint-disable react/button-has-type */
/* eslint-disable react/destructuring-assignment */
import React from 'react';
import {
  Button,
  SearchableSelect,
  Select,
  SelectContent,
  SelectItem,
  SelectTrigger,
  SelectValue,
} from '@jem-open/jem-ui';
import axios from 'axios';
import Swal from 'sweetalert2';

import { environment } from '../../../environment/environment';
import AddNewAdvanceBatchModal from './AddNewAdvanceBatchModal';
import AdvanceBatchItemsModal from './AdvanceBatchItemsModal';
import SubscriptionBatchItemsModal from './SubscriptionBatchItemsModal';
import AdvanceBatchList from './AdvanceBatchListComponent';
import SubscriptionBatchList from './SubscriptionBatchListComponent';
import AddNewSubscriptionBatchModal from './AddNewSubscriptionBatchModal';
import BulkDownloadButton from './components/BulkDownloadButton';
import { Pager } from '../../../components/pager';
import { initiateDownload } from './batchDownloadService';

const PAGE_SIZE = 50;

/**
 * @typedef {Object} BulkSelectionState
 * @property {number[]} selectedBatchIds
 * @property {number} selectedCount
 * @property {boolean} canDownload
 */

/**
 * @typedef {Object} DownloadState
 * @property {boolean} inProgress
 * @property {string|null} error
 */

/**
 * @summary Render AdvanceBatches component
 *
 * @param {object} props The components' props
 * @returns {Component}
 */

class AdvanceBatches extends React.Component {
  constructor(props) {
    super(props);
    this.getAdvanceBatches = this.getAdvanceBatches.bind(this);
    this.getSubscriptionBatches = this.getSubscriptionBatches.bind(this);
    this.state = {
      batch: 'advances',
      advanceBatches: null,
      subscriptionBatches: null,
      selectedEmployerId: '',
      allUniqueEmployers: [],
      activeEmployers: [],
      isLoadingActiveEmployers: false,
      bulkSelection: {
        selectedBatchIds: [],
        selectedCount: 0,
        canDownload: false,
      },
      downloadState: {
        inProgress: false,
        error: null,
      },
      isLoadingAdvanceBatches: false,
      isLoadingSubscriptionBatches: false,
      pagination: {
        currentPage: 1,
        pageSize: PAGE_SIZE,
        totalItems: 0,
        totalPages: 0,
      },
    };

    this.handleBulkSelectionChange = this.handleBulkSelectionChange.bind(this);
    this.handleBulkDownload = this.handleBulkDownload.bind(this);
    this.handlePageChange = this.handlePageChange.bind(this);
    this.handleBatchTypeChange = this.handleBatchTypeChange.bind(this);
    this.handleEmployerFilterChange = this.handleEmployerFilterChange.bind(this);
  }

  componentDidMount() {
    this.getAllUniqueEmployers();
    this.getActiveEmployers();
    this.getAdvanceBatches();
  }

  getBatchesForType() {
    if (this.state.batch === 'advances') {
      this.getAdvanceBatches();
    } else {
      this.getSubscriptionBatches();
    }
  }

  getConfigurationURL() {
    if (this.state.batch === 'advances') {
      return '/admin/advance_batches_configurations';
    }

    return '/admin/subscription_batches_configurations';
  }

  getAdvanceBatches(page = 1) {
    this.setState({ isLoadingAdvanceBatches: true });
    const { pageSize } = this.state.pagination;
    const offset = (page - 1) * pageSize;

    // Build queries with optional employer filter
    const countQuery = this.state.selectedEmployerId
      ? `query{allAdvanceBatchJobs(employerId: ${this.state.selectedEmployerId}){id}}`
      : 'query{allAdvanceBatchJobs{id}}';

    const dataQuery = this.state.selectedEmployerId
      ? `query{allAdvanceBatchJobs(limit: ${pageSize}, offset: ${offset}, employerId: ${this.state.selectedEmployerId}){id,requestedBy{username},payroll{name},employer{id,companyName}, dateCreated, status, startDate, endDate}}`
      : `query{allAdvanceBatchJobs(limit: ${pageSize}, offset: ${offset}){id,requestedBy{username},payroll{name},employer{id,companyName}, dateCreated, status, startDate, endDate}}`;

    // First get total count, then get paginated data
    const queries = [
      // Query for total count (without limit/offset)
      axios.post(`${environment.baseUrl}/graphql/`, {
        query: countQuery,
      }),
      // Query for paginated data
      axios.post(`${environment.baseUrl}/graphql/`, {
        query: dataQuery,
      })
    ];

    Promise.all(queries)
      .then(([countRes, dataRes]) => {
        const totalItems = countRes.data.data.allAdvanceBatchJobs.length;
        const totalPages = totalItems > 0 ? Math.ceil(totalItems / pageSize) : 0;

        this.setState((prevState) => ({
          advanceBatches: dataRes.data.data.allAdvanceBatchJobs,
          toggleAddNewBatchModal: false,
          toggleBatchItemsModal: false,
          isLoadingAdvanceBatches: false,
          pagination: {
            ...prevState.pagination,
            currentPage: page,
            totalItems,
            totalPages,
          },
        }));
      })
      .catch(() => {
        this.setState((prevState) => ({
          isLoadingAdvanceBatches: false,
          pagination: {
            ...prevState.pagination,
            totalItems: 0,
            totalPages: 0,
          },
        }));
      });
  }

  getSubscriptionBatches() {
    this.setState({ isLoadingSubscriptionBatches: true });
    axios
      .post(`${environment.baseUrl}/graphql/`, {
        query:
          'query{allSubscriptionBatchJobs{id,requestedBy{username},subscription{name},employer{companyName}, dateCreated, startDate, endDate}}',
      })
      .then((res) => {
        this.setState({
          subscriptionBatches: res.data.data.allSubscriptionBatchJobs,
          toggleAddNewBatchModal: false,
          toggleBatchItemsModal: false,
          isLoadingSubscriptionBatches: false,
        });
      })
      .catch(() => {
        this.setState({ isLoadingSubscriptionBatches: false });
      });
  }

  handleShowAddNewBatchModal = () => {
    this.setState((prevState) => ({
      toggleAddNewBatchModal: !prevState.toggleAddNewBatchModal,
    }));
  };

  handleShowAdvanceBatchItemsModal = (batchId) => {
    const matchingBatches = this.state.advanceBatches.filter(
      (batch) => parseInt(batch.id, 10) === parseInt(batchId, 10)
    );
    this.setState((prevState) => ({
      toggleBatchItemsModal: !prevState.toggleBatchItemsModal,
      activeBatch: matchingBatches[0],
    }));
  };

  handleShowSubscriptionBatchItemsModal = (batchId) => {
    const matchingBatches = this.state.subscriptionBatches.filter(
      (batch) => parseInt(batch.id, 10) === parseInt(batchId, 10)
    );
    this.setState((prevState) => ({
      toggleBatchItemsModal: !prevState.toggleBatchItemsModal,
      activeBatch: matchingBatches[0],
    }));
  };

  getAllUniqueEmployers = () => {
    axios
      .get(`${environment.baseUrl}/employers/`)
      .then((res) => {
        const allUniqueEmployers = (res.data || []).map(employer => ({
          value: employer.id,
          label: employer.company_name,
          companyName: employer.company_name,
        }));
        this.setState({ allUniqueEmployers });
      })
      .catch((error) => {
        // eslint-disable-next-line no-console
        console.error('Error fetching employers:', error);
      });
  };

  getUniqueEmployers = () => this.state.allUniqueEmployers;

  getActiveEmployers = () => {
    this.setState({ isLoadingActiveEmployers: true });
    axios
      .get(`${environment.baseUrl}/employers/?status=active`)
      .then((res) => {
        this.setState({ activeEmployers: res.data || [], isLoadingActiveEmployers: false });
      })
      .catch((error) => {
        // eslint-disable-next-line no-console
        console.error('Error fetching active employers:', error);
        this.setState({ isLoadingActiveEmployers: false });
      });
  };

  handleBulkSelectionChange = (selectionData) => {
    this.setState({
      bulkSelection: selectionData
    });
  };

  handleBulkDownload = async (batchIds) => {
    if (!Array.isArray(batchIds) || batchIds.length === 0) {
      Swal.fire('Error', 'No batches selected for download', 'error');
      return;
    }

    this.setState({
      downloadState: { inProgress: true, error: null }
    });

    try {
      const zipName = `advance_batches_${new Date().toISOString().split('T')[0]}`;
      await initiateDownload(batchIds, { zipName });

      const message = batchIds.length <= 10
        ? `Successfully downloaded ${batchIds.length} batches`
        : `Download initiated for ${batchIds.length} batches - this may take 1-2 minutes`;

      Swal.fire('Success', message, 'success');
      // Reset selection after successful download
      this.setState({
        bulkSelection: {
          selectedBatchIds: [],
          selectedCount: 0,
          canDownload: false,
        }
      });
    } catch (error) {
      const errorMessage = error?.message || 'An unexpected error occurred';
      Swal.fire('Download Failed', errorMessage, 'error');
      this.setState({
        downloadState: { inProgress: false, error: errorMessage }
      });
      return;
    }

    this.setState({
      downloadState: { inProgress: false, error: null }
    });
  };

  handlePageChange = (newPage) => {
    this.setState({
      bulkSelection: {
        selectedBatchIds: [],
        selectedCount: 0,
        canDownload: false,
      }
    });
    this.getAdvanceBatches(newPage);
  };

  handleBatchTypeChange = (obj) => {
    this.setState((prevState) => ({
      batch: obj.value,
      selectedEmployerId: '',
      bulkSelection: {
        selectedBatchIds: [],
        selectedCount: 0,
        canDownload: false,
      },
      pagination: {
        ...prevState.pagination,
        currentPage: 1,
      }
    }), () => {
      this.getBatchesForType();
    });
  };

  handleEmployerFilterChange = (option) => {
    this.setState((prevState) => ({
      selectedEmployerId: option?.value || '',
      bulkSelection: {
        selectedBatchIds: [],
        selectedCount: 0,
        canDownload: false,
      },
      pagination: {
        ...prevState.pagination,
        currentPage: 1,
      }
    }), () => {
      this.getAdvanceBatches(1);
    });
  };

  render() {
    const isAdvances = this.state.batch === 'advances';
    const employerOptions = [
      { value: '', label: 'All Employers' },
      ...this.getUniqueEmployers().map((emp) => ({
        value: String(emp.value),
        label: emp.label,
      })),
    ];
    return (
      <div className="min-h-screen bg-white p-md">
        <div
          className="-mx-md -mt-md mb-md flex flex-wrap items-center justify-between gap-sm px-md py-lg"
          style={{ backgroundColor: 'rgba(237,244,251,0.5)' }}>
          <div>
            <h1 className="m-none font-heading text-2xl font-semibold text-greyscale-text-title">
              Advance Batches
            </h1>
            <p className="m-none mt-xxs max-w-2xl text-sm text-greyscale-text-body">
              Generate, review and download advance and subscription batch
              files.
            </p>
          </div>
        </div>

        <div className="mb-md flex flex-wrap items-center gap-sm">
          <div className="w-56">
            <Select
              value={this.state.batch}
              onValueChange={(value) => this.handleBatchTypeChange({ value })}>
              <SelectTrigger>
                <SelectValue placeholder="Batch type" />
              </SelectTrigger>
              <SelectContent>
                <SelectItem value="advances">Advances</SelectItem>
                <SelectItem value="subscriptions">Subscriptions</SelectItem>
              </SelectContent>
            </Select>
          </div>
          {isAdvances && this.state.advanceBatches && (
            <div className="w-72">
              <SearchableSelect
                options={employerOptions}
                value={
                  this.state.selectedEmployerId
                    ? String(this.state.selectedEmployerId)
                    : ''
                }
                placeholder="All Employers"
                searchPlaceholder="Search employers..."
                emptyMessage="No employers found."
                onValueChange={(value) =>
                  this.handleEmployerFilterChange({ value })
                }
              />
            </div>
          )}
          <div className="ml-auto flex flex-wrap items-center gap-xs">
            {/* Show bulk download button for advances when batches are selected */}
            {isAdvances && this.state.bulkSelection.canDownload && (
              <BulkDownloadButton
                selectedBatchIds={this.state.bulkSelection.selectedBatchIds}
                selectedCount={this.state.bulkSelection.selectedCount}
                onDownload={this.handleBulkDownload}
                downloadState={this.state.downloadState}
              />
            )}
            <Button variant="primary" onClick={this.handleShowAddNewBatchModal}>
              New Batch
            </Button>
            <Button
              variant="outline"
              onClick={() =>
                this.props.history.push(this.getConfigurationURL())
              }>
              Configurations
            </Button>
          </div>
        </div>

        {this.state.batch === 'advances' ? (
          <>
            <AdvanceBatchList
              key={`${this.state.selectedEmployerId}-${this.state.pagination.currentPage}`}
              advanceBatches={this.state.advanceBatches}
              handleShowBatchItemsModal={this.handleShowAdvanceBatchItemsModal}
              selectedEmployerId={this.state.selectedEmployerId}
              onBulkSelectionChange={this.handleBulkSelectionChange}
              bulkSelection={this.state.bulkSelection}
              isLoading={this.state.isLoadingAdvanceBatches}
            />
            {this.state.advanceBatches &&
             !this.state.isLoadingAdvanceBatches &&
             this.state.pagination.totalItems > 0 && (
              <div className="mt-md flex justify-center">
                <Pager
                  currentPage={this.state.pagination.currentPage}
                  totalPages={this.state.pagination.totalPages}
                  onPageChange={this.handlePageChange}
                />
              </div>
            )}
          </>
        ) : (
          <SubscriptionBatchList
            subscriptionBatches={this.state.subscriptionBatches}
            handleShowBatchItemsModal={
              this.handleShowSubscriptionBatchItemsModal
            }
            isLoading={this.state.isLoadingSubscriptionBatches}
          />
        )}

        {this.state.batch === 'advances' &&
          Boolean(this.state.toggleAddNewBatchModal) && (
            <AddNewAdvanceBatchModal
              getAdvanceBatches={this.getAdvanceBatches}
              toggleAddNewBatchModal={this.state.toggleAddNewBatchModal}
              handleShowAddNewBatchModal={this.handleShowAddNewBatchModal}
              activeEmployers={this.state.activeEmployers}
              isLoadingActiveEmployers={this.state.isLoadingActiveEmployers}
            />
          )}

        {this.state.batch === 'subscriptions' &&
          Boolean(this.state.toggleAddNewBatchModal) && (
            <AddNewSubscriptionBatchModal
              getSubscriptionBatches={this.getSubscriptionBatches}
              toggleAddNewBatchModal={this.state.toggleAddNewBatchModal}
              handleShowAddNewBatchModal={this.handleShowAddNewBatchModal}
            />
          )}

        {this.state.batch === 'advances' &&
          this.state.toggleBatchItemsModal && (
            <AdvanceBatchItemsModal
              activeBatch={this.state.activeBatch}
              toggleBatchItemsModal={this.state.toggleBatchItemsModal}
              handleShowBatchItemsModal={this.handleShowAdvanceBatchItemsModal}
            />
          )}

        {this.state.batch === 'subscriptions' &&
          this.state.toggleBatchItemsModal && (
            <SubscriptionBatchItemsModal
              activeBatch={this.state.activeBatch}
              toggleBatchItemsModal={this.state.toggleBatchItemsModal}
              handleShowBatchItemsModal={
                this.handleShowSubscriptionBatchItemsModal
              }
            />
          )}
      </div>
    );
  }
}

AdvanceBatches.defaultProps = {
  AdvanceBatches: [],
};

AdvanceBatches.propTypes = {};

export default AdvanceBatches;
